module.exports = __webpack_public_path__ + "media/images/card_deck_icon-b4c9b5b9.jpg";